import { useEffect, useRef } from 'react'
import { useLocation } from 'react-router-dom'
import { useConfig } from '../auth'
import { safeReturnPath, startMicrosoftLogin } from '../lib/sso'
import { Alert, Button, Card, Spin, Typography } from 'antd'

const { Title, Text } = Typography

export default function Login () {
  const config = useConfig()
  const hasProviders = config.data.socialaccount?.providers?.some(provider => provider.id === 'microsoft')
  const location = useLocation()
  const params = new URLSearchParams(location.search)
  const next = safeReturnPath(params.get('next'))
  const manual = params.has('logged_out') || params.has('error')
  const started = useRef(false)

  useEffect(() => {
    if (hasProviders && !manual && !started.current) {
      started.current = true
      startMicrosoftLogin(next)
    }
  }, [hasProviders, manual, next])

  if (hasProviders && !manual) {
    return (
      <div role='status' style={{ minHeight: '60vh', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', gap: 16 }}>
        <Spin size='large' />
        <Text type='secondary'>Logging you in...</Text>
      </div>
    )
  }

  return (
    <div style={{ maxWidth: 380, margin: '48px auto' }}>
      <Card>
        <Title level={4} style={{ marginBottom: 4 }}>Login</Title>
        <Text type='secondary' style={{ fontSize: 13 }}>
          Sustainability Tool Kit
        </Text>

        <div style={{ marginTop: 20 }}>
          {hasProviders
            ? <>
                {params.has('error') && <Alert type='error' showIcon title='Microsoft sign-in failed. Please try again or contact IT.' />}
                <Button block onClick={() => startMicrosoftLogin(next)}>Microsoft</Button>
              </>
            : <Alert type='error' showIcon title='Microsoft sign-in is unavailable. Contact IT for assistance.' />}
        </div>
      </Card>
    </div>
  )
}
